import request from '@/api/request';
export const getsearch = (keyword, num) => request({ method: 'get', url: `/api/hotel/search?keyword=${keyword}&num=${num}` })